import { CardTemplate } from "../../templates/CardTemplate";
import { useForgotPasswordSendMail } from "./hook";
import { Button } from "../../atoms/Button";
import styled from "styled-components";

export const ForgotPasswordSendMailPage: React.FC = () => {
  const { handleForgotPasswordSendMail } = useForgotPasswordSendMail();

  return (
    <CardTemplate title="メール送信完了">
      <StyledTextContainer>
        パスワード再設定のメールを送信しました。
        <br />
        メールをご確認の上、パスワード再設定を行ってください。
      </StyledTextContainer>
      <Button
        text="戻る"
        variant="filled"
        onClick={handleForgotPasswordSendMail}
        fullWidth
      />
    </CardTemplate>
  );
};

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;
